import React, { useState } from 'react'
import './style.scss'
import Icon from 'react-icons-kit'
import { Link, useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { chevronLeft } from 'react-icons-kit/feather'
import { useQuery } from '../../../../components/query/Index'
import Requests from '../../../../utils/Requests/Index'

const Edit = () => {
    const { id } = useParams()
    const { values } = useQuery()
    const { register, handleSubmit, formState: { errors } } = useForm()
    const [isLoading, setLoading] = useState(false)
    const [header] = useState({
        headers: { Authorization: "Bearer " + localStorage.getItem('token') }
    })

    // Submit Form
    const onSubmit = async (data) => {
        try {
            setLoading(true)

            await Requests.Settings.ValueUpdate(id, values, data, header)
            setLoading(false)
        } catch (error) {
            if (error) console.log(error.response)
        }
    }

    return (
        <div className="item-store pb-4">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-padding">
                        <div className="card border-0 shadow-sm">
                            <div className="card-header p-3 p-lg-4 bg-white">
                                <div className="d-flex">
                                    <div><h6 className="mb-0">Edit field</h6></div>
                                    <div className="ml-auto">
                                        <Link
                                            type="button"
                                            to="/dashboard/website/settings-field/value"
                                            className="btn shadow-none rounded-circle"
                                        >
                                            <Icon icon={chevronLeft} size={22} />
                                        </Link>
                                    </div>
                                </div>
                            </div>


                            <div className="card-body p-3 p-lg-4">
                                <form onSubmit={handleSubmit(onSubmit)}>

                                    {/* Value */}
                                    <div className="form-group mb-4">
                                        {errors.newValues && errors.newValues.message ? (
                                            <p className="text-danger">{errors.newValues && errors.newValues.message}</p>
                                        ) : <p>Value</p>}

                                        <input
                                            type="text"
                                            name="newValues"
                                            defaultValue={values}
                                            className="form-control shadow-none"
                                            placeholder="Enter field value"
                                            {...register("newValues",{ required: "Value is required" })}
                                        />
                                    </div>


                                    <div className="text-end">
                                        <button type="submit" className="btn shadow-none" disabled={isLoading}>
                                            {isLoading ? <span>Updating...</span> : <span>Update</span>}
                                        </button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Edit;